<template>
  <div id="DmrTimelineOuter">
    <v-timeline id="DmrTimeline" class="pl-4 pr-4 width-100 align-center" align-top>
      <v-timeline-item
          v-for="(block) in timeGrouped"
          :key="'item-'+block.totalGameTime+'-'+block.action+'-'+block.period"
          fill-dot
          icon=""
          icon-color=""
          small
      >
        <template v-slot:icon>
          <v-card tile flat class="timelineTime theme-back">
            {{block.time}}
          </v-card>
          <v-card v-if="isCheckable(block)" flat tile class="timelineActions">
            <v-btn class="timelineAction theme-background theme-hightext theme-highborder" @click="checkTime(block.totalGameTime)" tile depressed>
              <v-icon class="theme-hightext">{{isChecked(block) ? 'mdi-check' : ''}}</v-icon>
            </v-btn>
          </v-card>
        </template>

        <template v-slot:opposite>
          <TimelineSide side="B" :block="block" :rejectReasons="rejectReasons"/>
        </template>

        <template v-slot:default>
          <TimelineSide side="A" :block="block" :rejectReasons="rejectReasons"/>
        </template>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import TimelineSide from "@/components/dmr/TimelineSide";
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';

export default {
  name: "TimelineDmr",
  components: {
    TimelineSide
  },
  props: {
    timelineData: Array,
    rejectReasons: Object
  },
  methods: {
    checkTime: function (totalGameTime) {
      eventBus.$emit(CONSTANTS.DMR.SELECT, totalGameTime);
    },
    isCheckable: function (block) {
      let checkable = false;

      if(block.action !== 'periodChange') {
        ['A', 'B'].forEach(function (team) {
          if(block[team]) {
            block[team].forEach(function (item) {
              if(!item.approved && !item.rejectReason && !item.draft) {
                checkable = true;
              }
            });
          }
        });
      }

      return checkable;
    },
    isChecked: function (block) {
      let checked = false;

      ['A', 'B'].forEach(function (team) {
        if(block[team]) {
          block[team].forEach(function (item) {
            if(item.checked) {
              checked = true;
            }
          });
        }
      });

      return checked;
    },
    isPeriod: function (item) {
      return item.action === 'periodchange';
    }
  },
  computed: {
    timeGrouped: function() {
      let self = this;
      let rtn = [];

      // JAVÍTÁS: Itt végezzük a végső szűrést közvetlenül a megjelenítés előtt.
      // Kiszűrjük, ha:
      // 1. A gyökérben deleted=true
      // 2. A params-ban deleted=true
      // 3. Az action típusa 'deleted' vagy 'remove'
      let orderedList = self.timelineData.filter(function(item) {
        if (!item) return false;

        const isDeletedRoot = item.deleted == 1 || item.deleted === true;
        const isDeletedParams = item.params && item.params.deleted === true;
        const isActionDelete = item.action === 'deleted' || item.action === 'remove';

        return !isDeletedRoot && !isDeletedParams && !isActionDelete;
      });

      // A csoportosító logika változatlan, de már a tisztított listán fut
      orderedList.forEach(function (item, index) {
        let isNew = true;

        if(index > 0 && item.totalGameTime !== undefined && item.totalGameTime !== null && orderedList[index-1].totalGameTime === item.totalGameTime) {
          if(!self.isPeriod(item)) {
            isNew = false;
          }

          if(self.isPeriod(item) && orderedList[index-1].action === 'periodChange') {
            isNew = false;
          }
        }

        if (isNew) {
          if(self.isPeriod(item)) {
            rtn.push({
              action: 'periodChange',
              time: item.time,
              period: item.period,
              totalGameTime: item.totalGameTime,
              ['A']: [item],
              ['B']: [item]
            });
          } else {
            rtn.push({
              action: 'normalAction',
              time: item.time,
              period: item.period,
              totalGameTime: item.totalGameTime,
              [item.team]: [item]
            });
          }
        } else {
          let count = rtn.length-1;

          if(rtn[count][item.team]) {
            rtn[count][item.team].push(item);
          } else {
            rtn[count][item.team] = [item];
          }
        }
      });

      return rtn;
    },
  }
}
</script>

<style>
#DmrTimelineOuter {
  /* JAVÍTÁS: ez a div a DmrScreen.vue SAJÁT #DmrTimelineOuter divje BELSEJÉBE
     ágyazódik (két elemnek volt ugyanaz az ID-je) - az a külső div már maga
     is a teljes rendelkezésre álló magasságot foglalja el és maga görget
     (overflow-y-auto). Az itteni "calc(100% - 100px)" egy régebbi, önállóan
     görgetett elrendezésből maradt vissza, és a már helyesen méretezett külső
     konténeren BELÜL vágott le feleslegesen 100px-et - ez okozta az üres,
     szürke sávot a DMR képernyő alján. A belső elemnek egyszerűen ki kell
     töltenie a szülőjét, a görgetést a külső div már elvégzi. */
  width: 100%;
  height: 100%;
}

#DmrTimeline {
  width: 100%;
}

#DmrTimeline:before {
  border-style: dotted;
  width: 1px;
  border-left-width: 0;
  border-right-width: 2px;
  border-top-width: 0;
  border-bottom-width: 0;
  background: transparent;
  height: 100%;
  top: 0;
}

#DmrTimeline.theme--light:before {
  border-right-color: #aaaaaa;
}

#DmrTimeline.theme--dark:before {
  border-right-color: #4d5269;
}

#DmrTimeline .v-timeline-item {
  flex-direction: row !important;
}

#DmrTimeline .v-timeline-item__divider {
  width: 90px;
  min-width: 90px;
}

#DmrTimeline .v-timeline-item__body {
  align-self: flex-start;
  /*padding-right: 16px;*/
  position: relative;
  max-width: calc(50% - 45px) !important;
  width: calc(50% - 45px) !important;
  background-color: transparent !important;
}

#DmrTimeline.theme--light .v-timeline-item__body:before {
  border-color: #000000;
}

#DmrTimeline.theme--dark .v-timeline-item__body:before {
  border-color: #ffffff;
}

#DmrTimeline .v-timeline-item__body:not(:empty):before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 45px);
  height: 0;
  border-width: 0;
  border-top-width: 1px;
  border-style: solid;
}

#DmrTimeline .v-timeline-item__opposite {
  align-self: flex-start;
  /*padding-left: 16px;*/
  position: relative;
  max-width: calc(50% - 45px) !important;
  width: calc(50% - 45px) !important;
  background-color: transparent !important;
}

#DmrTimeline.theme--dark .v-timeline-item__opposite:before {
  border-color: #ffffff;
}

#DmrTimeline.theme--light .v-timeline-item__opposite:before {
  border-color: #000000;
}

#DmrTimeline .v-timeline-item__opposite:not(:empty):before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  width: calc(100% + 45px);
  height: 0;
  border-width: 0;
  border-top-width: 1px;
  border-style: solid;
}

#DmrTimeline .v-timeline-item__dot {
  width: auto;
  height: auto;
  background-color: transparent;
  left: auto;
  box-shadow: none;
  border-radius: 0;
}

#DmrTimeline .v-timeline-item__dot .v-timeline-item__inner-dot {
  height: auto;
  width: auto;
  background-color: transparent !important;
  display: flex;
  flex-flow: column;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>

<style scoped>
.timelineTime {
  white-space: nowrap;
  line-height: 36px;
  height: 36px;
  font-size: 18px;
  font-weight: 900;
  transition: all 300ms;
  margin-top: 1px;
  position: relative;
}

.timelineActions {
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}

.timelineAction {
  min-width: 46px !important;
  width: 46px;
  min-height: 46px;
  height: 46px;
  border: 1px;
  border-style: solid;
}

.timelineAction:nth-child(n+2) {
  width: 45px;
  border-left-width: 0;
}
</style>
